<template>
  <div>
  
  <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
    
    <van-list
      v-model="loading"
      :finished="finished"
      :offset="offset"
      :immediate-check="ischeck"
      finished-text="没有更多了"
      @load="loadMore"
    >
    <div v-for="(item,index) in dataList" :key="index" >
            <div v-if="item.DeceasedInformationApiModelList.length > 1">
              <router-link to="/MemorialHall" class="hall-item">
                <van-swipe class="my-swipe" :loop="false" indicator-color="orange">
                        <van-swipe-item  v-for="clientitem in item.DeceasedInformationApiModelList" :key="clientitem.id"> 
                        <div class="hall-list" @click.prevent="getisPrivate(item)">
                          <div class="bd">
                            <h2 class="sz-name">{{item.Title}}</h2>
                            <div class="sz-des">
                              <P>逝者: {{clientitem.DeceasedName}}</P>
                              <P>馆号: TT{{item.SerialNumber}}</P>
                              <P>建馆人: {{item.MemberName}}</P>
                              <P>创建时间: {{$moment(item.BuildDateTime).format('YYYY-MM-DD')}}</P>
                              <P>访问量: {{item.ClickCount}}</P>
                            </div>
                          </div>
                          <div class="ft">
                            <img v-bind:src="clientitem.HeadPhoto" class="avatar">
                          </div>
                        </div>
                      </van-swipe-item>
                </van-swipe>
                <img  src="@/assets/images/double_tag_icon.png" class="double-tag" />
              </router-link>
            </div>
            <div v-else>
              <router-link to="/MemorialHall" class="hall-item">
                <div class="hall-list" @click.prevent="getisPrivate(item)">
                  <div class="bd">
                    <h2 class="sz-name">{{item.Title}}</h2>
                    <div class="sz-des">
                      <P>逝者: {{item.DeceasedInformationApiModelList[0].DeceasedName}}</P>
                      <P>馆号: TT{{item.SerialNumber}}</P>
                      <P>建馆人: {{item.MemberName}}</P>
                      <P>创建时间: {{$moment(item.BuildDateTime).format('YYYY-MM-DD')}}</P>
                      <P>访问量: {{item.ClickCount}}</P>
                    </div>
                  </div>
                  <div class="ft">
                    <img v-bind:src="item.DeceasedInformationApiModelList[0].HeadPhoto" class="avatar">
                  </div>
                </div>
              </router-link>
            </div>
          </div>
    </van-list>
  </van-pull-refresh>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
  data() {
    return {
      refreshing: false,
      loading: true,
      finished: false,
      offset: 100,
      ischeck: false,
      options: null,
      oldmemorialhalltypeval : 1,   // 老的type 值
      dataList: [],
    };
  },
  props : {
    readshowtypeid : {
        type : Number,
        default : 1,
    },
    memorialhalltype : {  // 1 推荐， 2 热门 ， 3 最新
        type : Number,
        default : 0,
    },
    currentind : {      // 下标
        type : Number,
    },
    active : {          // 当前页面
        type : Number,
    }
  },
  computed: {
      updatememorialhalltype(){
          return this.memorialhalltype; // 监听
      },
      updateactive(){
          return this.active; // 监听
      }
  },
  watch: {
    // 监听 memorialhalltype 的改变值事件
    updatememorialhalltype(newV,oldV) {
        var cur = this.active + 1;
        if (this.currentind != 0 && cur == this.currentind){
            this.oldmemorialhalltypeval = newV;
            this.onRefresh();
        }
    },
    // 监听 active 的改变值事件
    updateactive(newV, oldV){
        if (this.currentind!= 0 && newV + 1 == this.currentind){
          this.loading = false;
          if (this.oldmemorialhalltypeval != this.memorialhalltype){
              this.oldmemorialhalltypeval = this.memorialhalltype;
              this.onRefresh();
          }
        }
        
    }
},
  methods: {
    init() {
      var that = this;
      that.oldmemorialhalltypeval = this.memorialhalltype;
      that.oldactive = this.active;
      that.options = {
        type: "GetMemorialHallSearch",
        ReadShowType: this.readshowtypeid,
        MemorialHallType : this.memorialhalltype,
        pageIndex: 1
      };
      that.getList();
    },
    loadMore() {
      // console.log("我是loadMore=====" + this.currentind);
      if (this.currentind == this.active + 1){
        Object.assign(this.options, {
          pageIndex: this.options.pageIndex + 1,
          ReadShowType: this.readshowtypeid,
          MemorialHallType : this.memorialhalltype,
        });
        this.loading = true;
        this.getList();
      }
    },
    onRefresh() {
      // console.log("我是onRefresh======" + this.currentind);
      if (this.currentind == this.active + 1){
        this.finished = false;
        // 重新加载数据
        // 将 loading 设置为 true，表示处于加载状态
        this.loading = true;
        Object.assign(this.options, {
          pageIndex: 1,
          ReadShowType: this.readshowtypeid,
          MemorialHallType : this.memorialhalltype,
        });
        this.getList();
      }
    },
    getList() {
      // console.log("我是getList======" + this.currentind);
      if (this.currentind == this.active + 1){
        var that = this;
        this.$store.dispatch(this.options).then(
          res => {
            that.loading = false;
            if (that.refreshing) {
              that.refreshing = false;
            }

            if (res.MemorialHallSearchApiModelList.length == 0){
              that.finished = true;
            }

            if (res.MemorialHallSearchApiModelList.length < 10) {
              that.finished = true;
            }
            
            if (this.options.pageIndex > 1) {
              if (res.MemorialHallSearchApiModelList.length > 0) {
                res.MemorialHallSearchApiModelList.forEach(element => {
                  that.dataList.push(element);
                });
              }
            } 
            else {
              that.dataList = res.MemorialHallSearchApiModelList;
            }
          },
          error => {}
        );
      }
    },
    // 返回当前点击的 item 给父组件
    getisPrivate(data){
      //getisPrivate: 是父组件指定的传数据绑定的函数，data:子组件给父组件传递的数据
      this.$emit('getisPrivate', data)
    }
    
  },
  created() {
    var that = this;
    that.init();
  },
  
};
</script>

<style>
</style>